export function createURL(hyperLinkType, link) {
  const protocolName = hyperLinkType.split(":")[0];
  if (link.startsWith(protocolName)) {
    return link;
  }
  // convert http to https
  else if (protocolName === "https" && link.startsWith("http://")) {
    return "https://" + link.split("://")[1];
  } else {
    return hyperLinkType + link;
  }
}
